<div class="search-results-item d-flex align-items-center">
  <div class="avatar">
    <img [src]="event.icon_thumb | baseUrl" class="img-fluid" />
  </div>
  <div>
    <div class="name">{{ event.name | textTruncate: 50 }}</div>
    <div class="desc">{{ event.point }} &bull; {{ event.date_time }} </div>
  </div>
  <a href="#" class="link ml-auto" (click)="false" *ngIf="event.is_going">Going</a>
  <!-- <a href="#" class="link ml-auto" (click)="false" *ngIf="event.is_interested">Interested</a> -->
</div>
